import { render, staticRenderFns } from "./WysiwygInspector.vue?vue&type=template&id=73fc6e9c&lang=pug&"
import script from "./WysiwygInspector.vue?vue&type=script&lang=js&"
export * from "./WysiwygInspector.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygInspector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fc6e9c')) {
      api.createRecord('73fc6e9c', component.options)
    } else {
      api.reload('73fc6e9c', component.options)
    }
    module.hot.accept("./WysiwygInspector.vue?vue&type=template&id=73fc6e9c&lang=pug&", function () {
      api.rerender('73fc6e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/WysiwygInspector.vue"
export default component.exports